import {
  inviteAppointmentId,
  inviteLocationReference,
  invitePatientDisplay,
} from "../../invites/helpers/inviteTaskHelpers";
import { fetchAppointmentById } from "../../services/fetchAppointmentById";
import { toBookedRow } from "../transformers/bookedRowTransformers";
import type { BookedTeleconsultoriaRow } from "../types";

/** Atendimento encerrado/cancelado não entra em "Próximas". */
const CLOSED_STATUSES = new Set(["cancelled", "noshow", "entered-in-error", "fulfilled"]);

/**
 * Convites que aceitei → linhas de "Próximas teleconsultorias".
 * Cada Appointment é lido por `_id` + Location da Task (o scheduling exige o
 * filtro de Location; ele fica em outro servidor). Falha em um convite não
 * derruba os demais: aquele simplesmente não aparece.
 */
export async function listAcceptedInviteRows(
  acceptedInvites: fhir5.Task[],
): Promise<BookedTeleconsultoriaRow[]> {
  const rows = await Promise.all(
    acceptedInvites.map(async (task) => {
      try {
        const appointment = await fetchAppointmentById(
          inviteAppointmentId(task),
          inviteLocationReference(task),
        );
        if (!appointment || CLOSED_STATUSES.has(appointment.status || "")) return undefined;
        return toBookedRow(appointment, { fallbackPatientName: invitePatientDisplay(task) });
      } catch (error) {
        console.error("listAcceptedInviteRows", task.id, error);
        return undefined;
      }
    }),
  );
  return rows.filter((row): row is BookedTeleconsultoriaRow => Boolean(row));
}
